import React from "react";
import styled, { useTheme } from "styled-components";
import { Flex, KeyValue } from "../../components";
import { colorMixin } from "../../helpers";
import { TColor } from "../../types";

const Box = styled.div<{ $value: TColor }>`
    width: 100%;
    height: 80px;

    background-color: ${({ $value }) => colorMixin($value)};
    border: 1px solid ${colorMixin("border-primary-200")};
`;

interface IProps {
    value: TColor;
}

const ColorPreview: React.FC<IProps> = ({ value }) => {
    const {
        v2: { colors }
    } = useTheme();

    return (
        <Flex column spacing={1}>
            <Box $value={value} />
            <Flex column>
                <KeyValue translatedLabel="Key" value={value} />
                <KeyValue translatedLabel="HEX" value={colors[value]} />
            </Flex>
        </Flex>
    );
};

export default ColorPreview;
